import { PoposedToTheSubCommittee4FormContainer } from "../../../containers/borrowSystem/ProposedToTheSubCommittee/PoposedToTheSubCommittee4FormContainer";
export function PoposedToTheSubCommittee4FormPage () {

    return(
        <PoposedToTheSubCommittee4FormContainer/>
    )
}




